var _styled;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var StyledRow = styled('div')((_styled = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  margin: "0 0 " + SPACING.SCALE_3
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  flexDirection: 'row',
  marginBottom: SPACING.SCALE_5
}, _styled));
/**
 *
 * ### Usage
 *
 * Example
 * * https://codesandbox.io/s/x917knwm4z
 *
 * Simple
 * ```jsx
 * import GridRow from '@govuk-react/grid-row';
 * import GridCol from '@govuk-react/grid-col';
 *
 * <Fragment>
 *   <GridRow>
 *     <GridCol>
 *       ...
 *     </GridCol>
 *   </GridRow>
 * </Fragment>
 * ```
 *
 * ### References:
 * - https://github.com/alphagov/govuk_frontend_toolkit/blob/master/stylesheets/_grid_layout.scss
 * - https://github.com/alphagov/govuk_elements/blob/master/assets/sass/elements/_layout.scss
 *
 */

var GridRow = function GridRow(props) {
  return React.createElement(StyledRow, props);
};

export default GridRow;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/grid-row/es/index.js
// module id = 265
// module chunks = 0